import { render, staticRenderFns } from "./RankingAtendentes.vue?vue&type=template&id=2aa95510&scoped=true"
import script from "./RankingAtendentes.vue?vue&type=script&lang=js"
export * from "./RankingAtendentes.vue?vue&type=script&lang=js"
import style0 from "./RankingAtendentes.vue?vue&type=style&index=0&id=2aa95510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa95510",
  null
  
)

export default component.exports